import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import styled from 'styled-components';

const Container = styled.div``;
const Count = styled.span`
  font-size: 8px;
  ${fonts.helvetica['73-bold-extended']};
  letter-spacing: 0.02em;

  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 2;
  background: ${brand.red.base};
  color: white;
  padding: 3px;
  border-radius: 50%;
`;

export const GalleryIconStyles = {
  Container,
  Count,
};
